(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'vue', './error'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('vue'), require('./error'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.vue, global.error);
    global.index = mod.exports;
  }
})(this, function (exports, _vue, _error) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _vue2 = _interopRequireDefault(_vue);

  var _error2 = _interopRequireDefault(_error);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /* istanbul ignore next */
  var noop = function noop() {};

  // all active instances
  var instances = [];

  /**
   * Error factory
   *
   * @param {Object} props
   * @return {Error}
   */
  var generate = function generate(_ref) {
    var _ref$type = _ref.type,
        type = _ref$type === undefined ? 'error' : _ref$type,
        description = _ref.description,
        _ref$onShow = _ref.onShow,
        onShow = _ref$onShow === undefined ? noop : _ref$onShow,
        _ref$onHide = _ref.onHide,
        onHide = _ref$onHide === undefined ? noop : _ref$onHide,
        _ref$onRefresh = _ref.onRefresh,
        onRefresh = _ref$onRefresh === undefined ? noop : _ref$onRefresh;

    var ErrorConstructor = _vue2.default.extend(_error2.default);
    var vm = new ErrorConstructor({
      propsData: {
        type: type,
        description: description
      }
    }).$mount();

    instances.push(vm);

    vm.$on('input', function (val) {
      /* istanbul ignore else */
      if (!val) {
        vm.value = false;
      }
    });
    vm.$on('hide', function () {
      var index = instances.indexOf(vm);
      /* istanbul ignore else */
      if (index >= 0) {
        instances.splice(index, 1);
      }
      vm.$destroy();
      onHide();
    });
    vm.$on('show', function () {
      onShow();
    });
    vm.$on('click', function () {
      onRefresh();
    });

    vm.value = true;

    return vm;
  };

  /**
   * Dynamically create a error
   *
   * @param {Object} props
   * @return {Dialog}
   */
  _error2.default.show = function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$type = _ref2.type,
        type = _ref2$type === undefined ? 'error' : _ref2$type,
        description = _ref2.description,
        _ref2$onShow = _ref2.onShow,
        onShow = _ref2$onShow === undefined ? noop : _ref2$onShow,
        _ref2$onHide = _ref2.onHide,
        onHide = _ref2$onHide === undefined ? noop : _ref2$onHide,
        _ref2$onRefresh = _ref2.onRefresh,
        onRefresh = _ref2$onRefresh === undefined ? noop : _ref2$onRefresh;

    var vm = generate({
      type: type,
      description: description,
      onShow: onShow,
      onHide: onHide,
      onRefresh: onRefresh
    });

    return vm;
  };

  _error2.default.hide = function () {
    instances.forEach(function (instance) {
      instance.close();
    });
  };

  exports.default = _error2.default;
});